import { useUserStore } from "@/store/modules/user";

export default () => {
  return async (to, from, next) => {
    const userStore = useUserStore();

    // If user already fetched then go to the next() route
    if (userStore.getCurrentUser) {
      return next();
    }

    await userStore.initializeCurrentUser();
    return next();
  };
};
